export default __webpack_public_path__ + "static/media/SWT1990.34I-42360_-26090_0.af5ad49c.jpg";